import React from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "../../i18n/useTranslation";

const HomeFAQ = () => {
  const { t } = useTranslation();

  return (
    <section
      className="py-20 xl:py-24 bg-white bg-center"
      style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
    >
      <div className="container">
        <div className="text-center">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 font-medium uppercase rounded-full">
            {t("faqTag")}
          </span>
          <h2 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
            {t("faqTitle")}
          </h2>
          <p className="mb-24 text-base md:text-lg text-slate-500">
            {t("faqDesc")}
          </p>
        </div>
        <div className="flex flex-wrap -mx-4 text-slate-800 gap-y-16">
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                {t("faqQ1")}
              </h3>
              <p className="text-slate-500">
                {t("faqA1")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                {t("faqQ2")}
              </h3>
              <p className="text-slate-500">
                {t("faqA2")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                {t("faqQ3")}
              </h3>
              <p className="text-slate-500">
                {t("faqA3")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                {t("faqQ4")}
              </h3>
              <p className="text-slate-500">
                {t("faqA4")}
              </p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                {t("faqQ5")}
              </h3>
              <p className="text-slate-500">
                {t("faqA5")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                {t("faqQ6")}
              </h3>
              <p className="text-slate-500">
                {t("faqA6")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
